import { useEffect, useRef } from 'react';
/**
 * Returns a ref that indicates if the component is mounted or not.
 */
export function useIsMounted() {
    const isMounted = useRef(true);
    useEffect(() => () => {
        isMounted.current = false;
    }, []);
    return isMounted;
}
//# sourceMappingURL=useIsMounted.js.map